__webpack_require__.p = "https://new.praticaiok.com/";